import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { Brand } from "./components/Brand";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query-client";
import "./styles.css";
import "./accessibility.css";

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: boolean }
> {
  state = { error: false };
  static getDerivedStateFromError() {
    return { error: true };
  }
  render() {
    return this.state.error ? (
      <main className="fatal">
        <Brand />
        <h1>Your work is safe.</h1>
        <p>
          This view could not be loaded. No calculation or approval was
          submitted.
        </p>
        <button className="btn primary" onClick={() => location.reload()}>
          Reload workspace
        </button>
      </main>
    ) : (
      this.props.children
    );
  }
}
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
